import cn from 'classnames';
import React, { forwardRef, SVGAttributes } from 'react';
import { makeSSRCompatible } from '../../ssr/makeSSRCompatible';
import { useSvgOptimizer } from '../useSvgOptimizer';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles, { ssrStyleSheet } from './Svg.module.scss';

export interface SvgProps extends SVGAttributes<SVGElement> {
  disableOptimizer?: boolean;
}

interface Props extends SvgProps {
  optimizationId: string;
}

const Svg = forwardRef<SVGSVGElement, Props>(
  (
    {
      children,
      className,
      disableOptimizer,
      optimizationId,
      ...forwardedProps
    },
    ref
  ) => {
    const { keep, pack, reuse } = useSvgOptimizer(
      optimizationId,
      disableOptimizer !== true
    );

    return (
      <svg
        aria-hidden="true"
        focusable={false}
        height="1em"
        role="presentation"
        width="1em"
        {...forwardedProps}
        className={cn(styles.svg, className)}
        ref={ref}
      >
        {keep && children}
        {pack && <g id={optimizationId}>{children}</g>}
        {reuse && <use href={`#${optimizationId}`} />}
      </svg>
    );
  }
);

Svg.displayName = 'Svg';

export default makeSSRCompatible(Svg, ssrStyleSheet);
